import * as React from 'react';
import {Mutation} from 'react-apollo';

import {TextfieldWithButtons} from 'shells/textfield/textfield-with-buttons';

import type {
    setExchangeUsername as setExchangeUsernameMutation,
    setExchangeUsernameVariables as setExchangeUsernameMutationVariables,
} from 'nutshell-graphql-types';

import SET_EXCHANGE_USERNAME from './graphql/mutations/set-exchange-username.graphql';

type Props = {
    onCancel: (e?: React.SyntheticEvent<any>) => void;
    onSaveStart: () => void;
    onSaveSuccess: () => void;
    onSaveError: (arg1: string) => void;
};

class ExchangeSetUsernameMutation extends Mutation<
    setExchangeUsernameMutation,
    setExchangeUsernameMutationVariables
> {}

SetExchangeEmail.defaultProps = {
    onCancel: () => {},
    onSaveStart: () => {},
    onSaveSuccess: () => {},
    onSaveError: () => {},
};

export function SetExchangeEmail(props: Props) {
    const {onSaveError, onSaveStart, onSaveSuccess, ...restProps} = props;
    const [saveErrorMessage, setSaveErrorMessage] = React.useState<string | null | undefined>(
        undefined
    );

    return (
        <ExchangeSetUsernameMutation mutation={SET_EXCHANGE_USERNAME}>
            {(setExchangeUsername, {loading: isExchangeChanging}) => (
                <TextfieldWithButtons
                    name='emailAddress'
                    title='Connect to Microsoft Exchange'
                    subtitle='Enter the email address you use with Microsoft Exchange'
                    placeholder='Email address'
                    focusOnMount={true}
                    textfieldSize='big'
                    isSaving={isExchangeChanging}
                    onSave={(email) => {
                        // Clear error message if one has been set
                        if (saveErrorMessage) setSaveErrorMessage(undefined);

                        onSaveStart();
                        setExchangeUsername({variables: {username: email}})
                            .then(() => {
                                onSaveSuccess();
                            })
                            .catch((errMsg) => {
                                setSaveErrorMessage(errMsg);
                                onSaveError(errMsg);
                            });
                    }}
                    errorMessage={saveErrorMessage}
                    {...restProps}
                />
            )}
        </ExchangeSetUsernameMutation>
    );
}
